import axios from "axios";
import { getToken, getUser } from "../Utils/Common";
import token_valid from "./TokenValid";

//get sub order products by paging
const getSubOrderProductsByPaging = async (offset, pageSize, filter) => {
  console.log("Filter values in service: ", filter);
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/sub-order-product/all/" +
          offset +
          "/" +
          pageSize,
        {
          productName: filter._productName ? filter._productName.trim() : null,
          inputImportIds:
            filter._inputImportIds.length && filter._inputImportIds.length > 0
              ? filter._inputImportIds
              : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch((error) => {
        return "Something went wrong...";
      });
  }
};

//get sub order products by paging
const getSubProductsSelectionByPaging = async (offset, pageSize, filter) => {
  console.log("Filter values in service: ", filter);
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .post(
        process.env.REACT_APP_API_URL +
          "/api/sub-order-product/selection/all/" +
          offset +
          "/" +
          pageSize,
        {
          // turn undefined/null into '' first, then trim; fallback to null if empty
          productName: (filter?._productName ?? "").trim() || null,
          outputProductCode: (filter?._productCode ?? "").trim() || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response --", response.data.content);
        return response.data;
      })
      .catch((error) => {
        return "Something went wrong...";
      });
  }
};

//add sub order
const addSubOrderProduct = async (values) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();

    //get user name
    let user = getUser();
    console.log("User" + user.username);

    return axios
      .post(
        process.env.REACT_APP_API_URL + "/api/sub-order-product/add",
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(async (response) => {
        console.log(response);
        return true;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("add sub order error " + error);
        return false;
      });
  }
};

// //add sub order payment
// const addSubOrderPayment = async (values) => {
//   //check access tocken expiry function
//   let token_valid_result = await token_valid();
//   if (token_valid_result) {
//     let token = getToken();

//     //get user name
//     let user = getUser();
//     console.log("User" + user.username);

//     return axios
//       .post(
//         process.env.REACT_APP_API_URL + "/api/sub-order/payment",
//         {
//           orderId: values._orderId,
//           addedBy: user.username,
//           note: values._note,
//           amount: values._amount,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       .then(async (response) => {
//         console.log(response);
//         return true;
//       })
//       .catch((error) => {
//         // return "Something went wrong...";
//         console.log("add sub order payment error " + error);
//         return false;
//       });
//   }
// };

// //delete sub order payment
// const deleteSubOrderPayment = async (paymentId) => {
//   //check access tocken expiry function
//   let token_valid_result = await token_valid();
//   if (token_valid_result) {
//     let token = getToken();
//     return axios
//       .delete(
//         process.env.REACT_APP_API_URL +
//           "/api/sub-order/payment/delete/" +
//           paymentId,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response);
//         return true;
//       })
//       .catch((error) => {
//         // return "Something went wrong...";
//         console.log("Delete sub order payment " + error);
//         return false;
//       });
//   }
// };

//get Sub Order by Id
const getSubOrderProductById = async (productId) => {
  //check access tocken expiry function
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .get(
        process.env.REACT_APP_API_URL + "/api/sub-order-product/" + productId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log("Response all--", response.data);
        return response.data;
      })
      .catch((error) => {
        // return "Something went wrong...";
        console.log("get Sub Order " + error);
        return "Something went wrong...";
      });
  }
};

// //send for order completion Sub Order by Id
// const completeSubOrder = async (orderId) => {
//   //check access tocken expiry function
//   let token_valid_result = await token_valid();
//   if (token_valid_result) {
//     let token = getToken();
//     return axios
//       .get(
//         process.env.REACT_APP_API_URL +
//           "/api/sub-order/confirm-completion/" +
//           orderId,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response);
//         console.log("Response all--", response.data);
//         return true;
//       })
//       .catch((error) => {
//         // return "Something went wrong...";
//         console.log("get Sub Order " + error);
//         return false;
//       });
//   }
// };

// //confirm Sub Order by Id
// const confirmCompleteSuborder = async (orderId, isAccepted) => {
//   //check access tocken expiry function
//   let token_valid_result = await token_valid();
//   if (token_valid_result) {
//     let token = getToken();
//     return axios
//       .get(
//         process.env.REACT_APP_API_URL +
//           "/api/sub-order/confirm-received/" +
//           orderId +
//           "/" +
//           isAccepted,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response);
//         console.log("Response all--", response.data);
//         return true;
//       })
//       .catch((error) => {
//         // return "Something went wrong...";
//         console.log("get Sub Order " + error);
//         return false;
//       });
//   }
// };

// //delete sub order according to the given Id
// const deleteSubOrderById = async (orderId) => {
//   //check access tocken expiry function
//   let token_valid_result = await token_valid();
//   if (token_valid_result) {
//     let token = getToken();
//     return axios
//       .delete(
//         process.env.REACT_APP_API_URL + "/api/sub-order/delete/" + orderId,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       .then((response) => {
//         console.log(response);
//         return true;
//       })
//       .catch((error) => {
//         // return "Something went wrong...";
//         console.log("get Sale product " + error);
//         return false;
//       });
//   }
// };

const deleteSubOrderProductById = async (productId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .delete(
        process.env.REACT_APP_API_URL + "/api/sub-order-product/" + productId,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(() => ({ success: true }))
      .catch((error) => {
        const message =
          error.response?.data ||
          "Cannot be deleted. This product is linked to existing orders.";
        return { success: false, message };
      });
  }
};

const updateSubOrderProduct = async (productId, values) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .put(
        process.env.REACT_APP_API_URL + "/api/sub-order-product/" + productId,
        values,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("updateSubOrderProduct error:", error);
        return null;
      });
  }
};

const toggleSubOrderProductStatus = async (productId) => {
  let token_valid_result = await token_valid();
  if (token_valid_result) {
    let token = getToken();
    return axios
      .patch(
        process.env.REACT_APP_API_URL +
          "/api/sub-order-product/" +
          productId +
          "/toggle-status",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error("toggleSubOrderProductStatus error:", error);
        return null;
      });
  }
};

export {
  addSubOrderProduct,
  getSubOrderProductsByPaging,
  getSubOrderProductById,
  getSubProductsSelectionByPaging,
  deleteSubOrderProductById,
  updateSubOrderProduct,
  toggleSubOrderProductStatus,
};
